import controller from './PropertyDetailsCtrl';
import cssUtil from 'gw-portals-util-js/CssUtil';

import PropertyDetailsTemplate from 'text!./PropertyDetails.html';
import styles from './PropertyDetails-hashed.scss';

export default () => {
    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(PropertyDetailsTemplate, styles),
        controller,
        bindings: {
            incident: '=',
            cpPolicyExtension: '='
        }
    };
};